// extracted by mini-css-extract-plugin
var _1 = "AreaToolbar_buttonsGap__9aa4d";
export { _1 as "buttonsGap" }
